import React from 'react'
import Header from '../../Components/Header/Header'
import Slider from '../../Components/Slider/Slider'
import Topad from '../../Components/Topad/Topad'
import MonthlyLotteries from '../../Components/MonthlyLotteries/MonthlyLotteries'
import WinnerGallery from '../../Components/Winner/Winner'
import GetInTouch from '../../Components/GetInTouch/GetInTouch'
import Review from '../../Components/Review/Review'
import Footer from '../../Components/Footer/Footer'
import Slider2 from '../../Components/Slider/Slider2'
import UpcomingLotteries from '../../Components/UpcomingLotteries/UpcomingLotteries'

const Home = () => {
  return (
    <div>
      <Header />
      <Topad />
      <Slider />
      <MonthlyLotteries />
      <Slider2 />
      <UpcomingLotteries />

      <WinnerGallery />
      <GetInTouch />
      <Review />
      <Footer />
    </div>
  )
}

export default Home
